import { Button, TextButton } from "common/buttons";
import React from "react";
import styles from "./styles.module.css";
import { Box } from "common/components/Box";

export function useConfirmDialog(isLoading?: boolean) {
  const [text, setText] = React.useState<string>();
  const [okButtonText, setOkButtonText] = React.useState<string>();
  const [cancelButtonText, setCancelButtonText] = React.useState<string>();

  const [okButtonAction, setOkButtonAction] = React.useState<() => void>(
    () => () => undefined,
  );

  const showConfirm = ({
    text,
    okButtonText,
    okButtonAction,
    cancelButtonText,
  }: {
    text: string;
    okButtonText: string;
    okButtonAction: () => void;
    cancelButtonText?: string;
  }) => {
    setText(text);
    setOkButtonText(okButtonText);
    // Send as a function since we are storing a function, or else
    // it will evaluate the function to generate the state.
    setOkButtonAction(() => okButtonAction);
    setCancelButtonText(cancelButtonText);
  };

  const closeConfirmation = () => {
    setText(undefined);
  };

  const ConfirmBox = text && (
    <Box centeredContent={true} rounded>
      {text}
      <div className={styles.buttons}>
        <Button
          kind={isLoading ? "disabled" : "primary"}
          onClick={okButtonAction}
        >
          {okButtonText}
        </Button>
        {cancelButtonText && (
          <Button
            kind={isLoading ? "disabled" : "secondary"}
            onClick={closeConfirmation}
          >
            {cancelButtonText}
          </Button>
        )}
      </div>
    </Box>
  );

  const InlineConfirm = text && (
    <>
      <p className={styles.text}>{text}</p>
      <div className={styles.buttons}>
        <TextButton
          kind={isLoading ? "disabled" : "primary"}
          onClick={okButtonAction}
        >
          {okButtonText}
        </TextButton>
        {cancelButtonText && (
          <TextButton
            kind={isLoading ? "disabled" : "secondary"}
            onClick={closeConfirmation}
          >
            {cancelButtonText}
          </TextButton>
        )}
      </div>
    </>
  );

  return {
    showConfirm,
    closeConfirmation,
    ConfirmBox,
    InlineConfirm,
  };
}
